import { render, staticRenderFns } from "./CustomerBookings.vue?vue&type=template&id=25d335eb&"
import script from "./CustomerBookings.vue?vue&type=script&lang=js&"
export * from "./CustomerBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports